'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _MenuBody = require('./MenuBody');

require('./menu.less');

require('./upbutton.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Menu: {
        displayName: 'Menu'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Menu/default/MenuView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MIN_SCROLL_HEIGHT = 250;
var FPS = 1000 / 60;
var SCROLL_DELAY = 100;

var Menu = _wrapComponent('Menu')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(Menu, _Component);

    function Menu(props) {
        (0, _classCallCheck3.default)(this, Menu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props));

        _this.handleScroll = function (e) {
            if (window.pageYOffset > _this.refs.menu.offsetHeight && window.pageYOffset > MIN_SCROLL_HEIGHT) {
                if (!_this.state.showUpButton) {
                    _this.setState({ showUpButton: true });
                }
            } else {
                if (_this.state.showUpButton) {
                    _this.setState({ showUpButton: false });
                }
            }
        };

        _this.handleUpButtonClick = function (e) {
            setTimeout(function animateScroll() {
                window.scrollBy(0, -SCROLL_DELAY);
                if (window.pageYOffset - SCROLL_DELAY > 0) {
                    setTimeout(animateScroll, FPS);
                } else {
                    window.scrollTo(0, 0);
                }
            }, FPS);
        };

        _this.state = {
            showMenu: false,
            showUpButton: false,
            isLink: false
        };
        return _this;
    }

    (0, _createClass3.default)(Menu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('scroll', this.handleScroll);

            // если в корне есть товары, то "Каталог" будет ссылкой на корень каталога
            // this.props.hasOffersInRootCategory()
            //     .then((isLink) => {
            //         if (this.refs.menu) {
            //             this.setState({isLink: isLink});
            //         }
            //     });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.handleScroll);
        }

        //Сброс состояния при обновлении компонента

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            nextProps.drop && this.setState({ showMenu: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                showMenu = _props.showMenu,
                categories = _props.categories,
                lang = _props.lang;
            var _state = this.state,
                showUpButton = _state.showUpButton,
                isLink = _state.isLink;

            var classShowMenu = showMenu ? ' show_menu ' : '';
            var classShowBtn = showMenu ? ' show_btn ' : '';
            var classStaticMenu = this.props.drop ? '' : ' my_container_static ';
            var classDropBtn = this.props.drop ? ' drop_btn ' : '';
            var pattern = /^[\/]\w*/;
            var path = this.props.location.match(pattern);
            var isRoot = true;
            var isBannerVisible = path && (path[0] === '/' || path[0] === '/category');
            var creditPageBanner = null;
            if (isBannerVisible) {
                if (this.props.buyInCreditActive) {
                    creditPageBanner = _react3.default.createElement(
                        'div',
                        { style: { paddingTop: '3px' } },
                        _react3.default.createElement(
                            'a',
                            { href: 'https://acdn.tinkoff.ru/static/documents/706fc26a-4917-4ee8-ae95-7a2abab59a4b.pdf',
                                target: '__blank' },
                            _react3.default.createElement('img', { src: 'assets/images/banners/credit-banner.png', alt: '' })
                        )
                    );
                    if (this.props.buyInCredit.page) {
                        creditPageBanner = _react3.default.createElement(
                            'div',
                            { style: { paddingTop: '3px' } },
                            _react3.default.createElement(
                                _reactRouter.Link,
                                { to: '/page/' + this.props.buyInCredit.page, target: '__blank' },
                                _react3.default.createElement('img', { src: 'assets/images/banners/credit-banner.png', alt: '' })
                            )
                        );
                    }
                }
            }

            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-4 col-md-3 sidemenu-holder ' + classStaticMenu },
                _react3.default.createElement(
                    'div',
                    { ref: 'menu', className: 'side-menu animate-dropdown my_dropdown', onMouseLeave: this.handleMouseLeave },
                    isLink && !isRoot ? _react3.default.createElement(
                        _reactRouter.Link,
                        { to: '/' },
                        _react3.default.createElement(
                            'div',
                            { className: 'head my_dropdown_btn ' + classShowBtn + classDropBtn },
                            _react3.default.createElement('i', { className: 'fa fa-folder-o' }),
                            lang['store.menu.catalog']
                        )
                    ) : _react3.default.createElement(
                        'div',
                        { className: 'head my_dropdown_btn ' + classShowBtn + classDropBtn, onClick: this.props.toggleMenu },
                        _react3.default.createElement('i', { className: 'fa fa-folder-o' }),
                        lang['store.menu.catalog']
                    ),
                    _react3.default.createElement(
                        'nav',
                        { className: 'yamm megamenu-horizontal my_dropdown_content ' + classShowMenu, role: 'navigation' },
                        _react3.default.createElement(
                            'ul',
                            { className: 'nav' },
                            categories ? categories.map(function (category, index) {
                                return _react3.default.createElement(_MenuBody.MenuBody, {
                                    onClick_Category: _this2.props.onClick_Category,
                                    openMenu: _this2.props.openMenu,
                                    closeMenu: _this2.props.closeMenu,
                                    toggleMenu: _this2.props.toggleMenu,
                                    category: category,
                                    key: index
                                });
                            }) : null
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'up_button ' + (showUpButton ? ' show ' : ' hide '), title: lang['store.menu.up'], onClick: this.handleUpButtonClick },
                    _react3.default.createElement('i', { className: 'fa fa-angle-double-up', 'aria-hidden': 'true' })
                ),
                creditPageBanner
            );
        }
    }]);
    return Menu;
}(_react2.Component), _class.propTypes = {
    categories: _react2.PropTypes.array.isRequired,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = Menu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/default/MenuView.jsx
// module id = 1684
// module chunks = 0